import React, { FC } from 'react'
import { Button } from 'react-bootstrap'

export const BackButton: FC = () => {
  const goBack = () => {
    window.history.back()
  }
  return (
    <Button variant="info" onClick={goBack}>
      Back
    </Button>
  )
}
